import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-password-invalid-token',
  templateUrl: './forgot-password-invalid-token.component.html',
  styles: [],
})
export class ForgotPasswordInvalidTokenComponent implements OnInit {
  companyKey: string;

  ngOnInit(): void {
    this.handleCompanyKey();
  }

  handleCompanyKey() {
    const { hash } = window.location;
    this.companyKey = hash.replace('#/', '').split('/')[0];
  }
}
